import gql from 'graphql-tag';

export const REMOVE_COMMUNICATION = gql`
  mutation($id: String) {
    removeCommunication(id: $id) {
      id
    }
  }
`;

export const UPDATE_COMMUNICATION = gql`
  mutation($id: String, $input: EventCommunicationInput) {
    updateCommunication(id: $id, input: $input) {
      id
    }
  }
`;

export const ADD_COMMUNICATION = gql`
  mutation($input: EventCommunicationInput) {
    addCommunication(input: $input) {
      id
    }
  }
`;

export const SEND_TEST_EVENT_COMMUNICATION = gql`
  mutation($input: EventCommunicationInput, $event: EventInput) {
    sendTestEventCommunication(input: $input, event: $event) {
      id
    }
  }
`;

export const SEND_TEST_COMMUNICATION = gql`
  mutation($id: String, $input: EventCommunicationInput) {
    sendTestCommunication(id: $id, input: $input) {
      id
    }
  }
`;

export const SEND_EVENT_COMMUNICATION = gql`
  mutation($id: String, $input: EventCommunicationInput) {
    sendEventCommunication(id: $id, input: $input)
  }
`;
